@if (url(); as url) {
  <iframe [src]="url"></iframe>
} @else {
  <app-callout severity="info">{{ 'ship-location.imo-invalid' | translate }}</app-callout>
}
